export const languages = [
  {
    code: 'en_US',
    name: 'English',
  },
  {
    code: 'de_DE',
    name: 'German',
  },
  {
    code: 'es_ES',
    name: 'Spanish',
  },
  {
    code: 'ru_RU',
    name: 'Russian',
  },
  {
    code: 'sv_SE',
    name: 'Swedish',
  },
  {
    code: 'tl_PH',
    name: 'Tagalog',
  },
  {
    code: 'fr_FR',
    name: 'French',
  },
  {
    code: 'nl_NL',
    name: 'Dutch',
  },
  {
    code: 'it_IT',
    name: 'Italian',
  },
  {
    code: 'fi_FI',
    name: 'Finnish',
  },
  {
    code: 'el_GR',
    name: 'Greek',
  },
] as const
